import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import styled from "../teacherPages/teachersList/Teachers.module.css";
import maleAvatar from "../../assets/maleAvatar.webp";
import { SubmitButton } from "../../components/styled/styledbuttons/buttons";
import { useSelector } from "react-redux";
import { db, auth } from "../../firebase/firebase";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { API_BASE } from "../../config/api.js";

const Students = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const teacher = useSelector((state) => state.teacher.data);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const teacherId = teacher?.userId || auth.currentUser?.uid;
        if (!teacherId) {
          setLoading(false);
          return;
        }

        // Ensure teacherStudentLinks exist for legacy lessons (Admin SDK via API)
        try {
          const idToken = await auth.currentUser.getIdToken();
          await fetch(`${API_BASE}/sync-my-student-links`, {
            method: "POST",
            headers: { Authorization: `Bearer ${idToken}` },
          });
        } catch {
          /* non-fatal; new bookings still create links */
        }

        const eventsQuery = query(
          collection(db, "events"),
          where("teacherID", "==", teacherId)
        );

        const eventSnap = await getDocs(eventsQuery);

        const studentIds = [
          ...new Set(eventSnap.docs.map((d) => d.data().studentID).filter(Boolean)),
        ];

        if (studentIds.length === 0) {
          setStudents([]);
          setLoading(false);
          return;
        }

        const fetchedStudents = [];
        for (const studentId of studentIds) {
          const snap = await getDoc(doc(db, "students", studentId));
          if (snap.exists()) {
            fetchedStudents.push({ id: snap.id, ...snap.data() });
          }
        }

        setStudents(fetchedStudents);
      } catch (error) {
        console.error("Error fetching students:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [teacher?.userId]);

  if (loading) {
    return (
      <>
        <Navbar />
        <div className={styled.container}>
          <p>Loading students...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className={styled.container}>
        {students.map((student) => {
          const { firstName, lastName, gender, birthYear, profileImage } =
            student;
          return (
            <div className={styled.card} key={student.id || student.userId}>
              <img
                className={styled.img}
                src={profileImage || maleAvatar}
                alt=""
                onError={(e) => {
                  e.target.src = maleAvatar;
                }}
              />
              <div className={styled.name}>
                <h2>
                  {firstName} {lastName}
                </h2>
              </div>
              <div className={styled.genAge}>
                <h3>{birthYear ? new Date().getFullYear() - birthYear : ""}</h3>
                <h3>{gender}</h3>
              </div>
              <SubmitButton
                style={{ width: "80%", marginBottom: "10px" }}
                type="button"
                onClick={() =>
                  navigate(`/students/${student.id}`, { state: { student } })
                }
              >
                Details
              </SubmitButton>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Students;
